import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  // ADMIN_ONBOARD_SET_CURRENT_USER,
  // ADMIN_ONBOARD_SET_CURRENT_USER_DECODED_TOKEN,
  ADMIN_ONBOARD_SET_RESTAURANT_DETAILS,
  ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS,
  SUPERADMIN_RESTAURANT_CHAIN,
  SUPERADMIN_ONBOARDING_SUCCESS,
} from "../../types";

// import setVendorAuthToken from "../../utils/setAuthToken";
// import jwt_decode from "jwt-decode";
import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

import Alert from "react-s-alert";

export const superadmin_create_vendor =
  (formData, token, history) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let user_sign_up = await axios.post(`${serverApi}/vendor-user`, formData);
      if (user_sign_up.status === 201) {
        Alert.success("<h4>Vendor Create Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 2000,
          offset: 35,
        });
        let formDataId = {
          vendor_id: user_sign_up.data._id,
        };
        localStorage.setItem("vendorId", JSON.stringify(user_sign_up.data._id));
        dispatch(superadmin_create_and_update_restaurant(formDataId));
        dispatch(
          admin_create_new_subscription_for_vendor(token, formDataId.vendor_id)
        );
        history.push({
          pathname: "/addvendormapdetails",
        });
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_create_and_update_restaurant =
  (formData, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let add_restaurant_data = await axios.post(
        `${serverApi}/restaurant`,
        formData
      );
      if (add_restaurant_data.status === 201) {
        dispatch({
          type: ADMIN_ONBOARD_SET_RESTAURANT_DETAILS,
          payload: add_restaurant_data.data.restaurant._id
            ? add_restaurant_data.data.restaurant
            : add_restaurant_data.data.restaurant[0],
        });
        dispatch({
          type: SUPERADMIN_RESTAURANT_CHAIN,
          payload: add_restaurant_data.data.restaurantchain,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_create_restaurant_chains =
  (formData, history) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let map_details = await axios.post(
        `${serverApi}/restaurantchain`,
        formData
      );
      if (map_details.data) {
        dispatch({ type: CLEAR_LOADER });
        history.push("/addvendorrestauranttype");
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_create_new_subscription_for_vendor =
  (token, vendor_id, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let add_new_subscription_record = await axios.post(
        `${serverApi}/admin/subscription?vendor_id=${vendor_id}`,
        // formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_new_subscription_record.status === 201) {
        dispatch({
          type: ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: add_new_subscription_record.data,
        });
        onSuccess(
          dispatch(admin_get_new_subscription_for_vendor(token, vendor_id))
        );
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_new_subscription_for_vendor =
  (token, vendor_id) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let get_new_subscription_record = await axios.get(
        `${serverApi}/admin/subscription/${vendor_id}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_new_subscription_record.status === 200) {
        dispatch({
          type: ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: get_new_subscription_record.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
      dispatch({ type: CLEAR_LOADER });
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_new_subscription_for_vendor =
  (subscriptionId, formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let update_new_subscription_record = await axios.put(
        `${serverApi}/admin/subscription/${subscriptionId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_new_subscription_record.data) {
        dispatch({
          type: ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: update_new_subscription_record.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_new_subscription_for_vendor_table_management =
  (subscriptionId, formData, token, onSuccess, table, type) =>
  async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let update_new_subscription_record = await axios.put(
        `${serverApi}/admin/subscription/${subscriptionId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_new_subscription_record.data) {
        dispatch({
          type: ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS,
          payload: update_new_subscription_record.data,
        });
        onSuccess(table, update_new_subscription_record.data, type);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const submitVendorInfo = (history) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SUPERADMIN_ONBOARDING_SUCCESS });
  history.push("/addvendor");
};
